import { SvgProps } from "@/utils/types";

export const Pear = ({
  primaryColor = "#D4DF65",
  outlineColor = "#0E5654",
  className,
}: SvgProps) => {
  return (
    <svg
      width="56"
      height="65"
      viewBox="0 0 56 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_5_1114)">
        <path
          d="M22.7286 14.4583C26.4605 13.3947 34.3401 13.1646 36.9265 21.7993C38.7695 27.9726 48.7015 29.4488 49.5596 40.1314C50.656 53.6699 34.9497 57.4913 34.9497 57.4913C34.9497 57.4913 19.5816 62.4955 13.3966 50.4054C8.51694 40.8641 16.1896 34.384 14.5108 28.1667C12.1755 19.4645 18.9871 15.5245 22.7286 14.4583Z"
          fill={primaryColor}
        />
        <path
          d="M34.5455 59.6499C28.3545 61.3112 16.8591 61.4556 11.6583 51.2964C8.38487 44.8858 10.1358 39.6428 11.5502 35.422C12.4132 32.8504 13.1511 30.6231 12.6275 28.6721C9.9942 18.8593 17.4001 13.9314 22.1917 12.573C26.9808 11.205 35.881 11.4983 38.7944 21.2359C39.3759 23.1714 41.1774 24.6758 43.2594 26.4157C46.6728 29.2581 50.9279 32.8065 51.5048 39.9718C52.4725 51.9504 41.5157 57.8829 35.4842 59.3669C35.1874 59.4569 34.8713 59.5521 34.5429 59.6402L34.5455 59.6499ZM23.4852 16.2743C23.408 16.295 23.3307 16.3157 23.2534 16.3365C14.4884 18.8232 16.0029 26.2029 16.3917 27.6516C17.221 30.7423 16.2177 33.7553 15.2464 36.6562C13.95 40.545 12.6049 44.5609 15.1326 49.5047C17.3392 53.8306 21.1589 56.1809 26.4866 56.5113C30.6972 56.7688 34.2943 55.6275 34.333 55.6171L34.4006 55.599L34.4779 55.5783C34.5068 55.5705 38.1732 54.6487 41.6195 52.2122C45.9717 49.1392 47.9887 45.119 47.5901 40.2769C47.1407 34.7443 43.8873 32.0349 40.7397 29.4111C38.3796 27.4456 35.9505 25.4158 35.0246 22.3511C34.5998 20.9224 32.0495 13.9656 23.473 16.2672L23.4852 16.2743Z"
          fill={outlineColor}
        />
        <path
          d="M24.261 19.3586C24.1934 19.3767 24.1258 19.3949 24.0556 19.4033C22.9937 19.5744 21.9889 18.8397 21.8178 17.7778C21.5629 16.2103 20.3289 11.4577 18.0273 10.2117C17.0822 9.69915 16.7221 8.51189 17.2417 7.5545C17.7543 6.60936 18.9441 6.25899 19.8989 6.76895C24.3113 9.16728 25.5556 16.3503 25.6812 17.1656C25.8341 18.1599 25.2076 19.1046 24.261 19.3586Z"
          fill={outlineColor}
        />
        <path
          d="M35.5738 33.6964C36.774 33.3744 37.4858 32.1403 37.1638 30.9402C36.8417 29.74 35.6077 29.0281 34.4075 29.3502C33.2073 29.6723 32.4955 30.9063 32.8175 32.1065C33.1396 33.3067 34.3736 34.0185 35.5738 33.6964Z"
          fill={outlineColor}
        />
        <path
          d="M38.7009 31.884C38.7009 31.884 38.8996 33.2802 37.3251 34.3964C37.3251 34.3964 40.9355 36.0057 44.4686 43.6926C44.4686 43.6926 45.5973 36.4009 38.7106 31.8814L38.7009 31.884Z"
          fill={outlineColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_5_1114">
          <rect
            width="42.12"
            height="55.41"
            fill="white"
            transform="translate(0.539062 11.4052) rotate(-15.0217)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
